import { VARSHPHAL_SCOPE, VARSHPHAL_SHOWS } from "./varshphal-form";

/**
 * Under the form, before the chart is cast: what the chart shows and what this
 * page does not calculate. The shell (server HTML) and the live form render
 * this same block, so the words do not change when the island loads, and it
 * fills part of the slot's reserved height, which is the verdict's.
 */
export default function VarshphalShows() {
  return (
    <div className="mx-auto mt-4 w-full max-w-md rounded-lg border border-border-subtle bg-surface-canvas px-4 py-3">
      <p className="text-body-small font-semibold text-text-primary">What the chart shows</p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-body-small leading-relaxed text-text-secondary">
        {VARSHPHAL_SHOWS.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="mt-2 text-caption leading-snug text-text-muted">{VARSHPHAL_SCOPE}</p>
    </div>
  );
}
